export default Object.freeze({
  OFFSHORE: 'OFF'
})
